import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({
  container: {
    paddingTop: 40,
    paddingBottom: 80,
    alignSelf: 'center',
    width: 700,
  },

  cardBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 20,
    padding: 20,
    width: 700,
    lineHeight: '26px',
    backgroundColor: '#EAEFF2',
    borderRadius: '4px',
    cursor: 'move',
  },

  cardBoxReport: {
    position: 'relative',
    paddingLeft: 45,
    width: 510,
    backgroundColor: '#F7F8FA',
    cursor: 'default',
  },

  cardSelected: {
    opacity: 0,
  },

  label: {
    position: 'absolute',
    top: 20,
    left: 20,
  },

  cardText: {
    width: 596,
    wordBreak: 'break-word',
  },

  selectedIcon: {
    position: 'relative',
    marginLeft: 40,
    width: 14,
    height: 2,
    backgroundColor: '#C3CCD1',
    ':before': {
      content: "''",
      display: 'block',
      position: 'absolute',
      top: -8,
      left: 0,
      width: 14,
      height: 2,
      backgroundColor: '#C3CCD1',
    },
    ':after': {
      content: "''",
      display: 'block',
      position: 'absolute',
      bottom: -8,
      left: 0,
      width: 14,
      height: 2,
      backgroundColor: '#C3CCD1',
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/questions/sort/styles.js